"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));

var clsx_1 = __importDefault(require("clsx"));

var util_1 = require("./styles/util");

var _1 = require(".");

var DataListItem_1 = __importDefault(require("./DataListItem"));

var ListItem = function ListItem(_a) {
  var button = _a.button,
      link = _a.link,
      component = _a.component,
      href = _a.href,
      padding = _a.padding,
      margin = _a.margin,
      className = _a.className,
      datalist = _a.datalist,
      dataKeyWidth = _a.dataKeyWidth,
      datalistBreakpoint = _a.datalistBreakpoint,
      props = __rest(_a, ["button", "link", "component", "href", "padding", "margin", "className", "datalist", "dataKeyWidth", "datalistBreakpoint"]);

  if (typeof datalist === 'string') {
    var dataListProps = {
      datalist: datalist,
      dataKeyWidth: dataKeyWidth,
      datalistBreakpoint: datalistBreakpoint,
      button: button,
      link: link,
      component: component,
      href: href,
      onClick: props.onClick,
      className: className,
      children: props.children,
      id: props.id
    };
    return React.createElement(DataListItem_1.default, Object.assign({}, dataListProps));
  }

  var listItemComponent = button && !component ? 'li' : component;
  var listItemButton = button;

  if (link || href || listItemComponent === 'a') {
    var children = props.children,
        onClick = props.onClick,
        rest = __rest(props, ["children", "onClick"]);

    var itemClasses = clsx_1.default(className, 'py-0');
    var linkClasses = clsx_1.default(util_1.createPaddingClassNames({
      padding: padding
    }), util_1.createMarginClassNames({
      margin: margin
    }), 'py-1');
    var LinkComponent = listItemComponent || 'a';
    var listChildren = React.Children.toArray(children);
    var linkableChildren = listChildren.filter(function (child) {
      return "" + child.type !== "" + _1.List;
    });
    var childList = listChildren.filter(function (child) {
      return "" + child.type === "" + _1.List;
    });
    var linkProps = Object.assign(Object.assign({
      onClick: onClick,
      className: linkClasses,
      href: href
    }, rest), {
      children: linkableChildren
    });
    return React.createElement(ListItem_1.default, Object.assign({
      disableGutters: true,
      className: itemClasses
    }, rest), React.createElement(LinkComponent, Object.assign({}, linkProps)), childList);
  }

  var listItemClasses = clsx_1.default(className, util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }));
  return React.createElement(ListItem_1.default, Object.assign({
    className: listItemClasses,
    button: listItemButton,
    component: listItemComponent
  }, props));
};

exports.default = ListItem;